export default "__VITE_ASSET__c8b10f90__"